import Store, { action } from '../store';
import { LOADED_USERS, LOADING_USERS } from './constants';
import { SIGN_OUT_SUCCESS } from '../auth/constants';
import { IUser } from 'types';

export default class UserStore extends Store {
  // The current project the user is working on
  loaded = false;
  loading = false;
  users: IUser[] = [];

  getList() {
    return this.users;
  }

  getUser(userKey: string): IUser {
    return this.users.find(u => u.key === userKey);
  }

  @action(LOADING_USERS)
  handleUserLoading() {
    this.users = [];
    this.loading = true;
    this.loaded = false;
    this.emit();
  }

  @action(LOADED_USERS)
  handleUserLoaded(e, users) {
    this.users = users;
    this.loaded = true;
    this.loading = false;

    const step = 360 / users.length;
    for (let i = 0; i < users.length; i++) {
      users[i].color = `hsl(${Math.round((step * i + 41) % 360)},100%,55%)`;
    }
    this.emit();
  }

  @action(SIGN_OUT_SUCCESS)
  handleReset() {
    this.users = [];
    this.loaded = false;
  }
}
